import React, { Component } from 'react';
import { Card, Row, Col, Table, Button, Input, ButtonGroup, Alert as Alert2, Label } from "reactstrap";
import { api, filterHelper, stringHelper } from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const emptyVendor = {
  name: '',
  contactPerson: '',
  phone: '',
  email: '',
  inHouseVendor: false,
  vendorMechanicCount: 0 // for temporary use only
}

const emptyVendorMechanic = {
  id: 0,
  firstName: '',
  lastName: '',
  markedForDeletion: false
  // deactivatedAt: null
}
 
export default class Vendor extends Component {
  static displayName = Vendor.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      editVendor: null,
      VendorList: [],
      newVendorMechanic: null,
      vendorMechanicList: [],
      filters: [],
      pagedList: null,
      sortColumn: "Name",
      sortAscending: true
    }
    this.addVendor = this.addVendor.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSave = this.onSave.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);

    this.addNewVendorMechanic = this.addNewVendorMechanic.bind(this);
    this.onNewVendorMechanicInputChange = this.onNewVendorMechanicInputChange.bind(this);
    this.onCancelNewVendorMechanic = this.onCancelNewVendorMechanic.bind(this);
  }

  componentDidMount() {
    this.onChangeFilter({
      filterName: "activeOnly",
      value: true,
      filteredDisplay: "Active Only"
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/Vendors", payload)
      .then(response => {
        if (response && response.data) {
          // let list = response.data.dataSource;
          let formattedDataSource = _.map(response.data.dataSource, item => {
            return {
              id: item.id,
              name: item.name,
              contactPerson: stringHelper.nullableString(item.contactPerson),
              phone: stringHelper.nullableString(item.phone),
              email: stringHelper.nullableString(item.email),
              inHouseVendor: item.inHouseVendor,
              deactivatedAt: item.deactivatedAt,
              vendorMechanics: _.map(item.vendorMechanics, mechanic => {
                return {
                    ...mechanic, 
                    local_id:  -1*(item.vendorMechanics.indexOf(mechanic)+1)
                }
              }),
              vendorMechanicCount: item.vendorMechanics ? item.vendorMechanics.length : 0  // for temporary use only
            }
          });
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: formattedDataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            editVendor: null,
            vendorMechanicList: [],
            message: null,
            messageColor: null,
            isMessageVisible: false,
          });
        }
      })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addVendor() {
    this.setState({
      editVendor: emptyVendor
    })
  }

  onInputChange(e, fieldName) {
    this.setState({
      editVendor: { ...this.state.editVendor, [fieldName]: e.target.value }
    })
  }

  onCheckBoxChange(fieldName) {
    this.setState({
      editVendor: {
        ...this.state.editVendor,
        [fieldName]: !this.state.editVendor[fieldName]
      }
    });
  }

  onCancel() {
    this.setState({
      editVendor: null
    });
  }

  formatVendorMechanics() {
    const tempVendorMechanicList = [];
    _.each(this.state.vendorMechanicList, x => {
      const vendorMechanic = {
          Id: x.id,
          FirstName: x.firstName,
          LastName: x.lastName,
          VendorId: this.state.editVendor.id,
          MarkedForDeletion: x.markedForDeletion
      };
      tempVendorMechanicList.push(vendorMechanic);
    });
    return tempVendorMechanicList;
}

  onSave() {
    let vendor = Object.assign({}, this.state.editVendor);
    if (vendor.name === "") {
      this.setState({ message: "Vendor name is required.", messageColor: "danger" });
      return;
    }
    const vendorMechanics = this.formatVendorMechanics();
    let payload = {
      Name: vendor.name,
      ContactPerson: vendor.contactPerson,
      Phone: vendor.phone,
      Email: vendor.email,
      InHouseVendor: vendor.inHouseVendor,
      VendorMechanics: vendorMechanics
    }
    if (vendor.id) {
      payload.Id = vendor.id;
    }
    api.post("Admin/SaveVendor", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`${vendor.name} has been saved.`)
          this.refreshList();
          this.props.refreshAll();

        } else {
          Alert.error("An error occurred.  The vendor could not be created at this time.")
        }
      }).catch(error => Alert.error("There was an error creating the vendor."));
  }

  onEdit(vendorId) {
    let list = this.state.pagedList.list.slice();
    let vendor = _.find(list, t => {
      return t.id === vendorId
    })
    this.setState({
      editVendor: vendor,
      vendorMechanicList: vendor.vendorMechanics
    })
  }

  onDelete(vendorId) {
    if (!window.confirm(`Are you sure you'd like to delete this vendor?`)) return;

    api.delete(`Admin/DeleteVendor/${vendorId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Vendor was deleted.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Vendor cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the vendor.")
      });
  }

  onRevive(vendorId) {
    api.post("Admin/ReviveVendor", vendorId)
      .then(response => {
        if (response.data.success) {
          Alert.success("Vendor was revived.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Vendor cannot be revived at this time.")
        }
      }).catch(error => Alert.error("There was an error reviving the vendor."));
  }

  addNewVendorMechanic() {
    this.setState({
      newVendorMechanic: emptyVendorMechanic
    })
  }

  onNewVendorMechanicInputChange(e, fieldName) {
    this.setState({
      newVendorMechanic: { ...this.state.newVendorMechanic, [fieldName]: e.target.value }
    })
  }

  onSaveNewVendorMechanic() {
    let vendorMechanicToSave = Object.assign({}, this.state.newVendorMechanic);
    if (vendorMechanicToSave.firstName === "") {
      this.setState({ message: "Mecahnic first name is required.", messageColor: "danger" });
      return;
    }
    if (vendorMechanicToSave.lastName === "") {
      this.setState({ message: "Mecahnic last name is required.", messageColor: "danger" });
      return;
    }
    const vendorMechanics = this.state.vendorMechanicList.slice();
    vendorMechanicToSave = {
        ...vendorMechanicToSave,
        local_id: -1 * (this.state.editVendor.vendorMechanicCount + 1)
    }
    this.setState({
      newVendorMechanic: null,
      vendorMechanicList: [...vendorMechanics, vendorMechanicToSave], 
      editVendor: {
          ...this.state.editVendor,
          vendorMechanicCount: this.state.editVendor.vendorMechanicCount + 1
      }
    });
  }

  onCancelNewVendorMechanic() {
    this.setState({
      newVendorMechanic: null
    });
  }


  onEditVendorMechanic(vendorMechanicId) {
    const indexToEdit = _.findIndex(this.state.vendorMechanicList, {local_id: vendorMechanicId});
    let tempList = _.cloneDeep(this.state.vendorMechanicList);
    const snapshotItem = Object.assign({}, tempList[indexToEdit]);
    tempList[indexToEdit].isEditing = true;
    tempList[indexToEdit].pristine = snapshotItem;
    this.setState({
      vendorMechanicList: tempList
    });
  }

  onUpdateMechanicInputChange(fieldName, value, vendorMechanicId) {
    const tempList = this.state.vendorMechanicList.slice();
    const vendorMechanic = _.find(tempList, x => x.local_id === vendorMechanicId);
    vendorMechanic[fieldName] = value;
    this.setState({
      vendorMechanicList: tempList
    });
  }

  onSaveEditedVendorMechanic(vendorMechanicId) {
    const indexToEdit = _.findIndex(this.state.vendorMechanicList, {local_id: vendorMechanicId});
    let tempList = this.state.vendorMechanicList.slice();

    if ( tempList[indexToEdit].firstName === "") {
      this.setState({ message: "Mecahnic first name is required.", messageColor: "danger" });
      return;
    }
    if ( tempList[indexToEdit].lastName === "") {
      this.setState({ message: "Mecahnic last name is required.", messageColor: "danger" });
      return;
    }

    tempList[indexToEdit].isEditing = false;
    this.setState({
        vendorMechanicList: tempList,
        message: null,
        messageFlavor: null
    });
  }

  onCancelEditVendorMechanic(vendorMechanicId) {
    const indexToEdit = _.findIndex(this.state.vendorMechanicList, {local_id: vendorMechanicId});
    let tempList = this.state.vendorMechanicList.slice();
    tempList[indexToEdit] = Object.assign({}, tempList[indexToEdit].pristine);
    this.setState({
        vendorMechanicList: tempList,
        message: null,
        messageFlavor: null
    });
  }

  onDeleteVendorMechanic(vendorMechanicId) {
    if (!window.confirm(`Are you sure you'd like to delete this mechanic?`)) return;
    const indexToEdit = _.findIndex(this.state.vendorMechanicList, {local_id: vendorMechanicId});
    let tempList = _.cloneDeep(this.state.vendorMechanicList);
    tempList[indexToEdit].markedForDeletion = true;
    this.setState({
      vendorMechanicList: tempList
    });
  }

  render() {
    let editVendor = this.state.editVendor;
    return (
      <div>
        <Row>
          <Col><h5>Vendors</h5></Col>
          <Col className="mr-3">
            {this.state.editVendor ? null : (
              <Button size="sm" color="success" className="float-right" onClick={this.addVendor}>Add New Vendor</Button>
            )}
          </Col>
        </Row>
        {this.state.message ? (
          <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
        ) : null}

        {this.state.editVendor ? (
          <Card className="p-2">
            <Row>
              <Col>Vendor Name: 
                <Input
                  type="text"
                  name="name"
                  id="name"
                  onChange={(e) => this.onInputChange(e, "name")}
                  value={editVendor.name}
                  maxLength="60"
                />
              </Col>
              <Col>
                Contact Person:
                <Input
                  type="text"
                  name="contactPerson"
                  id="contactPerson"
                  onChange={e => this.onInputChange(e, "contactPerson")}
                  value={editVendor.contactPerson}
                  maxLength="60"
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md="6">Email: 
                <Input
                  type="text"
                  name="email"
                  id="email"
                  onChange={(e) => this.onInputChange(e, "email")}
                  value={editVendor.email}
                  maxLength="50"
                />
              </Col>
              <Col>
                Phone:
                <Input
                  type="text"
                  name="phone"
                  id="phone"
                  onChange={e => this.onInputChange(e, "phone")}
                  value={editVendor.phone}
                  maxLength="11"
                />
              </Col>
              <Col className="mt-4">
                <Label for="inHouseVendor">
                  <input
                    type="checkbox"
                    className="mr-2"
                    id="inHouseVendor"
                    name="inHouseVendor"
                    checked={editVendor.inHouseVendor}
                    value={editVendor.inHouseVendor}
                    onChange={() => this.onCheckBoxChange("inHouseVendor")}
                  />
                  Is In House Vendor?
                </Label>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md="8">
                <Row>
                  <Col><h5>Mechanics</h5></Col>
                  <Col className="mr-3">
                    {this.state.newVendorMechanic ? null : (
                      <Button size="sm" color="success" className="float-right" onClick={this.addNewVendorMechanic}>Add</Button>
                    )}
                  </Col>
                </Row>
                {this.state.newVendorMechanic 
                  ? <React.Fragment>
                      <Row>
                        <Col md="5">First Name: 
                          <Input
                            type="text"
                            name="firstName"
                            id="firstName"
                            onChange={(e) => this.onNewVendorMechanicInputChange(e, "firstName")}
                            value={this.state.newVendorMechanic.firstName}
                            maxLength="50"
                          />
                        </Col>
                        <Col md="5">
                          Last Name:
                          <Input
                            type="text"
                            name="lastName"
                            id="lastName"
                            onChange={e => this.onNewVendorMechanicInputChange(e, "lastName")}
                            value={this.state.newVendorMechanic.lastName}
                            maxLength="50"
                          />
                        </Col>
                        <Col md="2"> 
                          <ButtonGroup className="float-right">
                            <Button
                                className="secondary mt-4 buttonGroupSpacing"
                                size="sm"
                                onClick={() => this.setState({newVendorMechanic: null})}
                            >
                                <FontAwesomeIcon icon="times-circle" />
                            </Button>
                            <Button
                                className="cbdmdPrimary mt-4 buttonGroupSpacing"
                                size="sm"
                                onClick={() => this.onSaveNewVendorMechanic()}
                            >
                                <FontAwesomeIcon icon="plus" />
                            </Button>
                          </ButtonGroup>
                        </Col>
                      </Row>
                    </React.Fragment>
                  : null
                }
                <Row className="d-flex flex-row mt-2">
                  <Col>
                    <Table size="sm" responsive>
                      <thead>
                        <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.vendorMechanicList && this.state.vendorMechanicList.length > 0 ? (
                          this.state.vendorMechanicList.map(vendorMechanic => (
                            <tr key={`pg-${vendorMechanic.local_id}`}>
                              {vendorMechanic.isEditing
                              ? <React.Fragment>
                                  <td>
                                    <Input
                                      type="text"
                                      name="firstName"
                                      id="firstName"
                                      onChange={(event) => this.onUpdateMechanicInputChange(
                                        event.target.name,
                                        event.target.value,
                                        vendorMechanic.local_id)} 
                                      value={vendorMechanic.firstName}
                                      maxLength="50"
                                    />
                                  </td>
                                  <td>
                                    <Input
                                      type="text"
                                      name="lastName"
                                      id="lastName"
                                      onChange={(event) => this.onUpdateMechanicInputChange(
                                        event.target.name,
                                        event.target.value,
                                        vendorMechanic.local_id)} 
                                      value={vendorMechanic.lastName}
                                      maxLength="50"
                                    /> 
                                  </td>
                                  <td className="text-right">
                                    <ButtonGroup>
                                      <Button
                                        className="cbdmdPrimary buttonGroupSpacing"
                                        onClick={() => this.onSaveEditedVendorMechanic(vendorMechanic.local_id)}
                                        size="sm"
                                      >
                                          <FontAwesomeIcon icon="save" />
                                      </Button>
                                      <Button
                                        className="secondary buttonGroupSpacing"
                                        onClick={() => this.onCancelEditVendorMechanic(vendorMechanic.local_id)}
                                        size="sm"
                                      >
                                        <FontAwesomeIcon icon="times-circle" />
                                      </Button>
                                    </ButtonGroup>
                                  </td>
                                </React.Fragment>
                              : <React.Fragment>
                                  {vendorMechanic.deactivatedAt || vendorMechanic.markedForDeletion
                                  ? null
                                  : <React.Fragment>
                                      <td>{vendorMechanic.firstName}</td>
                                      <td>{vendorMechanic.lastName}</td>
                                      <td>
                                        <ButtonGroup className="float-right">
                                          <React.Fragment>
                                            <Button
                                              size="sm"
                                              className="cbdmdPrimary buttonGroupSpacing"
                                              onClick={() => this.onEditVendorMechanic(vendorMechanic.local_id)}
                                              // disabled={this.state.editVendorMechanic !== null}
                                              title="Edit"
                                            >
                                              <FontAwesomeIcon
                                                icon="edit"
                                                className="ml-1 mt-0 mb-0 mr-1 pointer"
                                                title="Edit"
                                              />
                                            </Button>
                                            <Button
                                              size="sm"
                                              className="cbdmdDanger buttonGroupSpacing"
                                              onClick={() => this.onDeleteVendorMechanic(vendorMechanic.local_id)}
                                              // disabled={this.state.editVendorMechanic !== null}
                                              title="Delete"
                                            >
                                              <FontAwesomeIcon
                                                icon="trash-alt"
                                                className="ml-1 mt-0 mb-0 mr-1 pointer "
                                                title="Delete"
                                              />
                                            </Button>
                                          </React.Fragment>
                                        </ButtonGroup>
                                      </td>
                                    </React.Fragment>
                                  }
                                </React.Fragment>
                              }
                            </tr>
                          ))
                        ) : (
                            <tr>
                              <td>
                                No Records available
                            </td>
                            </tr>
                          )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" color="secondary" className="buttonGroupSpacing" onClick={this.onCancel}>Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onSave()}>{editVendor.id ? "Update" : "Save"}</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>   
        ) : null}



        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName=" Vendor Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="contactPerson"
                  displayName=" Contact Person"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="Phone"
                  displayName=" Phone"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="Email"
                  displayName=" Email"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <ActiveToggleFilter
                  filterName="inHouseVendor"
                  displayName="In House Vendor?"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "inHouseVendor",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Contact Person</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>In House Vendor?</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(vendor => (
                    <tr key={`pg-${vendor.id}`}>
                      <td>{vendor.name}</td>
                      <td>{vendor.contactPerson}</td>
                      <td>{vendor.phone}</td>
                      <td>{vendor.email}</td>
                      <td>
                          {vendor.inHouseVendor ? (
                            <FontAwesomeIcon
                              icon="check-circle"
                              className="ml-1 mt-0 mb-0 mr-2 pointer bool-icon"
                              title="Yes"
                            />
                          ) : null}
                        </td>
                      <td>
                        <ButtonGroup className="float-right">
                          {vendor.deactivatedAt === null ? (
                            <React.Fragment>
                              <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onEdit(vendor.id)} disabled={this.state.editVendor !== null} title="Edit">
                                <FontAwesomeIcon
                                  icon="edit"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer"
                                  title="Edit"
                                />
                              </Button>
                              <Button size="sm" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(vendor.id)} disabled={this.state.editVendor !== null} title="Delete">
                                <FontAwesomeIcon
                                  icon="trash-alt"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer "
                                  title="Delete"
                                />

                              </Button>
                            </React.Fragment>
                          ) : (
                              <Button size="sm" className="cbdmdInfoTeal" onClick={() => this.onRevive(vendor.id)} disabled={this.state.editVendor !== null}>Revive</Button>
                            )}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                    <tr>
                      <td>
                        No Records available
                    </td>
                    </tr>
                  )}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />

          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Vendor.js